<div class="box">
  <div class="num"> {{ num }} </div>
  <div class="desc"> {{ description }} </div>
</div>
